import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=2c1bc636&"
import script from "./Pricing.vue?vue&type=script&lang=js&"
export * from "./Pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports